import React, { useEffect } from "react"
import { CardImg, Col, ModalBody, Row } from "reactstrap"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import { Field, formValueSelector, initialize, reduxForm } from "redux-form"
import {
  CustomImageField,
  MultipleSelectField,
  PhoneField,
  SwitchInputField,
  TextField,
} from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import { mapContactToEditContactForm, verifyLink } from "./utils"

const EditContactModal = ({
  contact,
  handleSubmit,
  metaTags,
  profile_pic,
  initializeForm,
  userMetaTags,
  change,
  loading,
}) => {
  useEffect(() => {
    initializeForm(mapContactToEditContactForm({ ...contact, userMetaTags }))
  }, [])

  return (
    <ModalBody>
      <Row className="my-3 px-3">
        <Col className="align-self-center" style={{ textAlign: "center" }}>
          <CardImg
            src={
              profile_pic && profile_pic?.editedImage
                ? profile_pic?.editedImage
                : "https://admin.dev.markedprivate.com/app/images/profile_placeholder.jpg"
            }
            alt="image"
            className="rounded-circle avatar-xl"
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center mb-2">
        <Col xs="auto">
          <Field
            component={CustomImageField}
            name="profile_pic"
            onDelete={() => {
              change("delete_file", 1)
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <p style={{ color: "#485ec4" }}>
            <b>Admin Use Only</b>
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name="notes" component={TextField} label="Notes" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="tags"
            component={MultipleSelectField}
            label="Tags"
            options={metaTags.map(tag => ({
              value: tag?.id,
              label: tag?.tag,
            }))}
            placeholder="Enter tag"
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <p style={{ color: "#485ec4" }}>
            <b>Account Information</b>
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name="name" component={TextField} label="Name" disabled />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="email" component={TextField} label="Email" disabled />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12}>
          <p style={{ color: "#485ec4", margin: "0px" }}>
            <b>Social Profile</b>
          </p>
        </Col>
        <Col>
          <span>
            (Below is how the user completed their social profile on the app to
            be viewed by all)
          </span>
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="public"
            component={SwitchInputField}
            uncheckedIcon={false}
            checkedIcon={false}
            onColor="#2ECC71"
            offColor="#E74C3C"
            height={20}
            width={40}
            handleDiameter={18}
            label="Public"
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="displayName"
            component={TextField}
            label="Display Name"
            disabled
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="displayEmail"
            component={TextField}
            label="Display Email"
            disabled
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="phone" component={PhoneField} label="Phone" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="gender" component={TextField} label="Gender" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="birthday" component={TextField} label="Birthday" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="title" component={TextField} label="Title/Profession" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="company" component={TextField} label="Company" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="Bio" component={TextField} label="Bio" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="hobbies" component={TextField} label="Hobbies" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="facebook"
            component={TextField}
            label="Facebook"
            validate={[verifyLink]}
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="instagram"
            component={TextField}
            label="Instagram"
            validate={[verifyLink]}
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="linkedin"
            component={TextField}
            label="LinkedIn"
            validate={[verifyLink]}
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="pinterest"
            component={TextField}
            label="Pinterest"
            validate={[verifyLink]}
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="twitter"
            component={TextField}
            label="X (Twitter)"
            validate={[verifyLink]}
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="youtube"
            component={TextField}
            label="Youtube"
            validate={[verifyLink]}
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="tiktok"
            component={TextField}
            label="TikTok"
            validate={[verifyLink]}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center mt-3">
        <Col xs="auto">
          <SaveButton
            content="Save"
            type="button"
            onClick={handleSubmit}
            loading={loading}
          />
        </Col>
      </Row>
    </ModalBody>
  )
}

const selector = formValueSelector(FORM_NAMES.EDIT_CONTACT)

const mapStateToProps = state => ({
  metaTags: state.Tags.metaTags,
  profile_pic: selector(state, "profile_pic"),
  userMetaTags: state.people.userMetaTags,
  loading: state.people.loading,
})

const mapDispatchToProps = dispatch => ({
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.EDIT_CONTACT, values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.EDIT_CONTACT, `${field}`, value)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.EDIT_CONTACT })(EditContactModal))
